// extracted by mini-css-extract-plugin
export var box = "works-module--box--1xtLV";
export var title = "works-module--title--39uw4";